import { render, staticRenderFns } from "./EmployeeFairPayCardView.vue?vue&type=template&id=1abfa76a&scoped=true"
import script from "./EmployeeFairPayCardView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeFairPayCardView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmployeeFairPayCardView.vue?vue&type=style&index=0&id=1abfa76a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abfa76a",
  null
  
)

export default component.exports